/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type InventoryQueueTypeEnum = 'INBOUND' | 'OUTBOUND';

export const InventoryQueueTypeEnum = {

    INBOUND: 'INBOUND' as InventoryQueueTypeEnum,

    OUTBOUND: 'OUTBOUND' as InventoryQueueTypeEnum
};

